import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";

const AddSubscription = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    price: "",
    type: "",
    duration: "",
    description: "",
  });

  const planTypes = [
    { value: "free", label: "Free" },
    { value: "starter", label: "Starter" },
    { value: "pro", label: "Pro" },
    { value: "enterprise", label: "Enterprise" },
  ];

  const onSave = () => {
    if (isValidForm()) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.PLAN_UPDATE : API_URL.PLAN_SAVE;
      const payload = id
        ? {
            id: formValue.id,
            name: formValue.name,
            price: formValue.price,
            duration: parseInt(formValue.duration),
            type: formValue.type,
            description: formValue.description,
          }
        : {
            name: formValue.name,
            price: formValue.price,
            type: formValue.type,
            duration: parseInt(formValue.duration),
            description: formValue.description,
          };

      axios
        .post(pUrl, payload)
        .then((res) => {
          if (res.data.status === 1) {
            let message = id
              ? "Plan Updated Successfully."
              : "Plan Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/settings/subscription");
          } else {
            toast.error(res.data.data || "Failed to save plan", {
              autoClose: 3000,
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(
            error.response?.data?.message || "Something went wrong",
            { autoClose: 3000 }
          );
        });
    } else {
      setLoading(false);
      setError(true);
      toast.error("Please fill all required fields", { autoClose: 3000 });
    }
  };

  const isValidForm = () => {
    if (
      !formValue.name ||
      !formValue.price ||
      !formValue.type ||
      !formValue.duration ||
      !formValue.description
    ) {
      return false;
    }
    if (isNaN(formValue.duration) || parseInt(formValue.duration) <= 0) {
      return false;
    }
    return true;
  };

  const onEdit = () => {
    setLoading(true);
    axios
      .post(API_URL.PLAN_GET, { id: id })
      .then((res) => {
        if (res.data.status === 1) {
          setFormValue({
            id: res.data.data.id,
            name: res.data.data.name || "",
            price: res.data.data.price || "",
            type: res.data.data.type || "",
            duration: res.data.data.duration || "",
            description: res.data.data.description || "",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(
          error.response?.data?.message || "Failed to load plan",
          { autoClose: 3000 }
        );
      });
  };

  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Plan</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center justify-content-end">
            <Link
              to={"/settings/subscription"}
              className="btn btn-secondary"
            >
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>
                        Name<span className="required-star">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formValue.name}
                        className={
                          isRequiredField("name")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="name"
                        onChange={(event) => {
                          setFormValue({
                            ...formValue,
                            name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>
                        Type<span className="required-star">*</span>
                      </label>
                      <select
                        name="type"
                        value={formValue.type}
                        className={
                          isRequiredField("type")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="type"
                        onChange={(event) => {
                          setFormValue({
                            ...formValue,
                            type: event.target.value,
                          });
                        }}
                      >
                        <option value="">Select Type</option>
                        {planTypes.map((type) => (
                          <option key={type.value} value={type.value}>
                            {type.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>
                        Price<span className="required-star">*</span>
                      </label>
                      <input
                        type="number"
                        name="price"
                        value={formValue.price}
                        className={
                          isRequiredField("price")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="price"
                        step="0.01"
                        min="0"
                        onChange={(event) => {
                          setFormValue({
                            ...formValue,
                            price: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>
                        Duration (days)<span className="required-star">*</span>
                      </label>
                      <input
                        type="number"
                        name="duration"
                        value={formValue.duration}
                        className={
                          isRequiredField("duration")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="duration"
                        min="1"
                        onChange={(event) => {
                          setFormValue({
                            ...formValue,
                            duration: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="form-group">
                      <label>
                        Description<span className="required-star">*</span>
                      </label>
                      <textarea
                        name="description"
                        value={formValue.description}
                        className={
                          isRequiredField("description")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="description"
                        rows="4"
                        onChange={(event) => {
                          setFormValue({
                            ...formValue,
                            description: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group text-right">
                      <button
                        type="submit"
                        onClick={onSave}
                        disabled={loading}
                        className="btn btn-primary"
                      >
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Watch color={"white"} height={20} width={20} />
                          </div>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubscription;

